<template>
  <div class="card-module download-card">
    <div class="module-title">
      <i class="iconfont icon-shouji" style="font-size: 20px" />
      {{ $t('home.appDownloadMethod') }}
    </div>

    <!-- Android 部分 -->
    <div class="app-item">
      <div class="app-header">
        <i class="iconfont icon-anzhuo" style="font-size: 20px" /> Android
      </div>
      <div class="app-body">
        <!-- 直接放 v-html，不限制容器大小，完全自适应 -->
        <div class="qr-box" v-html="qrCodeHtml" />

        <div class="app-info">
          <el-link :underline="false" type="primary" @click="copyLink">
            {{ $t('home.scanOrLinkDownload') }}
          </el-link>
          <div class="url-text">
            {{ urlData }}
          </div>
        </div>
      </div>
    </div>

    <el-divider />

    <!-- iOS 部分 -->
    <div class="app-item">
      <div class="app-header"><i class="iconfont icon-pingguo" style="font-size: 20px" /> iOS</div>
      <div class="app-body">
        <div style="margin: 20px 10px 0 0">
          <el-tooltip placement="right">
            <template #content>
              <img alt="ios" src="@/assets/images/Apple1.jpg" style="width: 400px">
            </template>
            <img alt="ios" src="@/assets/images/Apple1.jpg" style="width: 120px">
          </el-tooltip>
        </div>
        <div class="app-info">
          <div style="font-size: 15px; font-weight: 500">{{ $t('home.searchAppStore') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qrcode from 'qrcode-generator';
import { homepageGetLatestH5PDALinkApi } from '@/api/newExpressAPI';

export default {
  data() {
    return {
      urlData: '',
      qrCodeHtml: ''
    };
  },
  mounted() {
    this.getAppLink();
  },
  methods: {
    getAppLink() {
      homepageGetLatestH5PDALinkApi().then((res) => {
        if (res.code === 200) {
          this.urlData = res.data?.url;
          this.generateQRCode(this.urlData);
        }
      });
    },
    generateQRCode(url) {
      if (!url) return;
      const qr = qrcode(0, 'M');
      qr.addData(url);
      qr.make();
      // 使用最简单的默认参数生成，不强制尺寸
      this.qrCodeHtml = qr.createImgTag();
    },
    copyLink() {
      if (!this.urlData) {
        this.$message.warning('当前暂无下载链接');
        return;
      }
      if (navigator.clipboard) {
        navigator.clipboard.writeText(this.urlData).then(() => {
          this.$message.success('已复制');
        });
      } else {
        const input = document.createElement('input');
        input.value = this.urlData;
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        this.$message.success('已复制');
      }
    }
  }
};
</script>

<style scoped>
.card-module {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  height: 600px;
  box-sizing: border-box;
}

.module-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 15px;
}

.module-title i {
  margin-right: 8px;
  color: #303133;
}

.app-item {
  margin-bottom: 10px;
}

.app-header {
  font-weight: 600;
  margin-bottom: 10px;
  color: #303133;
}

.app-body {
  display: flex;
  gap: 15px;
  align-items: flex-start;
}

/* 完全自适应，不加宽高，不加 padding，不加背景 */
.qr-box {
  /* 容器不写 width 和 height，子元素撑开多大就是多大 */
}

.app-info {
  flex: 1;
}

.url-text {
  font-size: 12px;
  color: #909399;
  word-break: break-all;
  margin-top: 5px;
  line-height: 1.4;
}
</style>
